<template>
  <section class="container">
    <div class="show">
      <pdf :src="localUrl"  />
    </div>
  </section>
  

  
</template>
<script>
import pdf from 'vue-pdf'
import axios from 'axios'
export default {
  name: 'VPdf',
  components: {
    pdf
  },
  props: {
    url: [String, Object]
  },
  data() {
    return {
      localUrl: '',
    }
  },
  watch: {
    url: {
      immediate: true,
      handler(val) {
        this.localUrl = val
        // url 做了跨域處理，不需要下面步驟了
        // =================================
        // this.getFile(val)
        // this.localUrl = val
        // console.log(val)
        // this.urlToBase64(val).then(res => {
        //   console.log(res, '==')
        // })
      }
    }
  },
  methods: {
    getFile(url) {
      console.log(url)
      axios({
        method: 'get',
        url
      }).then(res => {
        // debugger
      }).catch(err => {
        console.log(err, '===error===')
      })
    },
    urlToBase64(url) {
      return new Promise((resolve, reject) => {
        let image = new Image()
        image.onload = function() {
          let canvas = document.createElement('canvas')
          canvas.width = 400
          canvas.height = 400
          canvas.getContext('2d').drawImage(image, 0, 0)
          let result = canvas.toDataURL('image/png')
          resolve(result)
        }
        image.setAttribute('crossOrigin', 'Anonymous')
        image.src = url
        image.onerror = () => {
          reject(new Error('error'))
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
}
</style>